export enum StrapiTemplatesEnum {
  'landing-templates.australia' = 'australiaPromo',
  'landing-templates.modern' = 'modernPromo',
  'landing-templates.katsubet' = 'katsubetPromo',
  'landing-templates.modern2' = 'modern2Promo',
  'landing-templates.modern-multi' = 'modernPromo',
  'landing-templates.modern2-multi' = 'modern2Promo',
}
